import { Component, computed, OnInit, signal } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Enums } from '../../../shared/enums';
import { IMPORTS } from './_imports';

@Component({
    selector: 'app-ribs',
    templateUrl: './ribs.component.html',
    styleUrl: './ribs.component.scss',
    standalone: true,
    imports: IMPORTS
})
export class RibsComponent implements OnInit {
    // #region [signals]
    $isLandingPage = signal(false);
    $env = signal(null as string);
    $environment = signal(null as string);
    // #endregion

    // #region [computeds]
    $shouldHideEnvironment = computed(() => this.$env()?.toLowerCase() == 'prd' || this.$isLandingPage());
    // #endregion

    constructor(private cookieService: CookieService) {
        this.$isLandingPage.set(window?.location?.pathname == Enums.PagesPaths.LandingPage);
    }

    ngOnInit() {
        this.$env.set(atob(this.cookieService.get('prodest-eflow-env')).toLowerCase());

        switch (this.$env()) {
            case 'loc':
                this.$environment.set(Enums.Messages.EnvironmentLocalhost);
                break;

            case 'des':
                this.$environment.set(Enums.Messages.EnvironmentDevelopment);
                break;

            case 'hom':
                this.$environment.set(Enums.Messages.EnvironmentStaging);
                break;

            case 'tre':
                this.$environment.set(Enums.Messages.EnvironmentLearning);
                break;
        }
    }

    // #region [===== private methods =====]
    // #endregion
}
